import CircularProgress from "@mui/material/CircularProgress";

import { DashLoaderContainer } from "./styles.js";

export const DashLoader = ({ text = "Loading..." }) => (
  <DashLoaderContainer className="dash-loader">
    <CircularProgress enableTrackSlot />
    <span>{text}</span>
  </DashLoaderContainer>
);
